import Subnavigation from './subnavigation'
import ImageGallery from './image_gallery'

export const bindAll = ($doc) => {
  if ($doc.find('.js-subnavigation').length > 0) {
    $doc.find('.js-subnavigation').map(function () {
      new Subnavigation($(this), $doc.find('.js-subnavigation-headlines h2'))
    })
  }
  if ($doc.find('.js-image-gallery').length > 0) {
    ImageGallery()
  }
}

$(() => {
  bindAll($(document))
})
